import { main } from '@mindsciences/clarity-core/main';
import { AppModule } from './app/app.module';

main(AppModule);
